import { $InjectorLike, Transition, UrlService } from '@uirouter/core';

import { SessionModel }   from '../../app-lite/sessions/models/session';
import { SessionService } from '../../app-lite/sessions/session.service';

export function CoreStates (
  $stateProvider     : ng.ui.IStateProvider,
  $urlRouterProvider : ng.ui.IUrlRouterProvider,
  $urlServiceProvider: UrlService
) {
  $stateProvider
  .state({
    name      : 'app',
    template  : '<ui-view></ui-view>',
    url       : '?disconnect',
    redirectTo: ( transition : Transition ) => {
      const sessionApi : SessionService = transition.injector().get('sessionObjAPI');

      return sessionApi.isSuperUser()
        ? 'app.admin-dashboard'
        : 'app.dashboard';
    },
    resolve: {
      translateReady: ( $translate : ng.translate.ITranslateService ) : ng.IPromise<any> => $translate.onReady()
    }
  });

  $urlRouterProvider.otherwise(( $injector : $InjectorLike ) => {
    const sessionApi : SessionService = $injector.get('sessionObjAPI');
    const session    : SessionModel   = sessionApi.base();

    return session?.puppet_session && session?.company_settings.branding_group === 'bosch'
      ? '/reports'
      : (
        sessionApi.isSuperUser()
          ? '/admin_dashboard'
          : '/dashboard'
      );
  });

  $urlServiceProvider.deferIntercept();
}